function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function tryPopulateFpsTelemetry(detail, telemetryReportData) {
    var _detail_devicePerformance;
    var averageJsAnimationThreadTiming;
    var maxJsAnimationThreadTiming;
    if (((_detail_devicePerformance = detail.devicePerformance) === null || _detail_devicePerformance === void 0 ? void 0 : _detail_devicePerformance.fps) && detail.devicePerformance.fps.length > 0) {
        var fpsData = detail.devicePerformance.fps;
        maxJsAnimationThreadTiming = 0;
        averageJsAnimationThreadTiming = fpsData.reduce(function(total, next) {
            maxJsAnimationThreadTiming = next.value > maxJsAnimationThreadTiming ? next.value : maxJsAnimationThreadTiming;
            return total + next.value;
        }, 0) / fpsData.length;
        telemetryReportData.currentJsAnimationThreadTiming = fpsData[fpsData.length - 1].value.toString();
        telemetryReportData.averageJsAnimationThreadTiming = averageJsAnimationThreadTiming === null || averageJsAnimationThreadTiming === void 0 ? void 0 : averageJsAnimationThreadTiming.toString();
        telemetryReportData.maxJsAnimationThreadTiming = maxJsAnimationThreadTiming.toString();
    }
}
export function buildTelemetryData(detail) {
    var _detail_devicePerformance_memory, _detail_devicePerformance, _detail_devicePerformance1;
    var telemetryReportData = {};
    var playerStats = detail.playerStats;
    var vstStats = detail.vstMetrics;
    var k;
    var j;
    for(j in vstStats){
        telemetryReportData[j] = '' + vstStats[j];
    }
    for(k in playerStats){
        var _playerStats_memory;
        if (k === 'bufferedInfo' && playerStats.bufferedInfo) {
            telemetryReportData[k] = '';
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = Object.entries(playerStats.bufferedInfo)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var _step_value = _sliced_to_array(_step.value, 2), key = _step_value[0], value = _step_value[1];
                    var m = value === null || value === void 0 ? void 0 : value.map(function(param) {
                        var start = param.start, end = param.end;
                        return "{start:".concat(start, ",end:").concat(end, "},");
                    });
                    telemetryReportData[k] += "".concat(key, ":[").concat(m, "],");
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        } else if (k === 'memory' && ((_playerStats_memory = playerStats.memory) === null || _playerStats_memory === void 0 ? void 0 : _playerStats_memory.usage) && playerStats.memory.usage.length > 0) {
            calculateMemoryInfo(telemetryReportData, playerStats.memory);
        } else {
            telemetryReportData[k] = '' + playerStats[k];
        }
    }
    tryPopulateFpsTelemetry(detail, telemetryReportData);
    if (((_detail_devicePerformance = detail.devicePerformance) === null || _detail_devicePerformance === void 0 ? void 0 : (_detail_devicePerformance_memory = _detail_devicePerformance.memory) === null || _detail_devicePerformance_memory === void 0 ? void 0 : _detail_devicePerformance_memory.usage) && ((_detail_devicePerformance1 = detail.devicePerformance) === null || _detail_devicePerformance1 === void 0 ? void 0 : _detail_devicePerformance1.memory.usage.length) > 0) {
        calculateMemoryInfo(telemetryReportData, detail.devicePerformance.memory);
    }
    return telemetryReportData;
}
function calculateSystemMemory(telemetryReportData, systemMemory) {
    var _systemMemory_availableSizeInBytes, _systemMemory_totalPhysicalSizeInBytes, _systemMemory_committedSizeInBytes;
    telemetryReportData.systemAvailableMemory = ((_systemMemory_availableSizeInBytes = systemMemory.availableSizeInBytes) === null || _systemMemory_availableSizeInBytes === void 0 ? void 0 : _systemMemory_availableSizeInBytes.toString()) || 'N/A';
    telemetryReportData.systemTotalMemory = ((_systemMemory_totalPhysicalSizeInBytes = systemMemory.totalPhysicalSizeInBytes) === null || _systemMemory_totalPhysicalSizeInBytes === void 0 ? void 0 : _systemMemory_totalPhysicalSizeInBytes.toString()) || 'N/A';
    telemetryReportData.systemCommittedMemory = ((_systemMemory_committedSizeInBytes = systemMemory.committedSizeInBytes) === null || _systemMemory_committedSizeInBytes === void 0 ? void 0 : _systemMemory_committedSizeInBytes.toString()) || 'N/A';
}
function calculateAppMemory(telemetryReportData, appMemory) {
    var _appMemory_expectedTotalCommitLimit, _appMemory_peakPrivateCommitUsage, _appMemory_privateCommitUsage, _appMemory_totalCommitLimit, _appMemory_totalCommitUsage, _appMemory_memoryUsage, _appMemory_memoryUsageLevel, _appMemory_memoryUsageLimit, _appMemory_expectedMemoryUsageLimit;
    telemetryReportData.appMemoryExpectedTotalCommitLimit = ((_appMemory_expectedTotalCommitLimit = appMemory.expectedTotalCommitLimit) === null || _appMemory_expectedTotalCommitLimit === void 0 ? void 0 : _appMemory_expectedTotalCommitLimit.toString()) || 'N/A';
    telemetryReportData.appMemoryPeakPrivateCommitUsage = ((_appMemory_peakPrivateCommitUsage = appMemory.peakPrivateCommitUsage) === null || _appMemory_peakPrivateCommitUsage === void 0 ? void 0 : _appMemory_peakPrivateCommitUsage.toString()) || 'N/A';
    telemetryReportData.appMemoryPrivateCommitUsage = ((_appMemory_privateCommitUsage = appMemory.privateCommitUsage) === null || _appMemory_privateCommitUsage === void 0 ? void 0 : _appMemory_privateCommitUsage.toString()) || 'N/A';
    telemetryReportData.appMemoryTotalCommitLimit = ((_appMemory_totalCommitLimit = appMemory.totalCommitLimit) === null || _appMemory_totalCommitLimit === void 0 ? void 0 : _appMemory_totalCommitLimit.toString()) || 'N/A';
    telemetryReportData.appMemoryTotalCommitUsage = ((_appMemory_totalCommitUsage = appMemory.totalCommitUsage) === null || _appMemory_totalCommitUsage === void 0 ? void 0 : _appMemory_totalCommitUsage.toString()) || 'N/A';
    telemetryReportData.appMemoryUsage = ((_appMemory_memoryUsage = appMemory.memoryUsage) === null || _appMemory_memoryUsage === void 0 ? void 0 : _appMemory_memoryUsage.toString()) || 'N/A';
    telemetryReportData.appMemoryUsageLevel = ((_appMemory_memoryUsageLevel = appMemory.memoryUsageLevel) === null || _appMemory_memoryUsageLevel === void 0 ? void 0 : _appMemory_memoryUsageLevel.toString()) || 'N/A';
    telemetryReportData.appMemoryUsageLimit = ((_appMemory_memoryUsageLimit = appMemory.memoryUsageLimit) === null || _appMemory_memoryUsageLimit === void 0 ? void 0 : _appMemory_memoryUsageLimit.toString()) || 'N/A';
    telemetryReportData.appExpectedMemoryUsageLimit = ((_appMemory_expectedMemoryUsageLimit = appMemory.expectedMemoryUsageLimit) === null || _appMemory_expectedMemoryUsageLimit === void 0 ? void 0 : _appMemory_expectedMemoryUsageLimit.toString()) || 'N/A';
}
function calculateProcessMemory(telemetryReportData, processMemory) {
    var _processMemory_privateWorkingSetUsage, _processMemory_totalWorkingSetUsage;
    telemetryReportData.processMemoryPrivateWorkingSetUsage = ((_processMemory_privateWorkingSetUsage = processMemory.privateWorkingSetUsage) === null || _processMemory_privateWorkingSetUsage === void 0 ? void 0 : _processMemory_privateWorkingSetUsage.toString()) || 'N/A';
    telemetryReportData.processMemoryTotalWorkingSetUsage = ((_processMemory_totalWorkingSetUsage = processMemory.totalWorkingSetUsage) === null || _processMemory_totalWorkingSetUsage === void 0 ? void 0 : _processMemory_totalWorkingSetUsage.toString()) || 'N/A';
}
function calculateUsedHeapStats(usage) {
    var maxUsedHeapMemory = 0;
    var averageUsedHeapMemory = usage.reduce(function(total, next) {
        maxUsedHeapMemory = next.value > maxUsedHeapMemory ? next.value : maxUsedHeapMemory;
        return total + next.value;
    }, 0) / usage.length;
    return {
        average: averageUsedHeapMemory,
        max: maxUsedHeapMemory
    };
}
function calculateMemoryInfo(telemetryReportData, memoryInfo) {
    var _memoryInfo_memoryLimit;
    var memoryUsage = memoryInfo.usage;
    var _calculateUsedHeapStats = calculateUsedHeapStats(memoryInfo.usage), maxUsedHeapMemory = _calculateUsedHeapStats.max, averageUsedHeapMemory = _calculateUsedHeapStats.average;
    telemetryReportData.currentUsedHeapMemory = memoryUsage[memoryUsage.length - 1].value.toString();
    telemetryReportData.averageUsedHeapMemory = averageUsedHeapMemory.toString();
    telemetryReportData.maxUsedHeapMemory = maxUsedHeapMemory.toString();
    telemetryReportData.maxAvailableHeapMemory = ((_memoryInfo_memoryLimit = memoryInfo.memoryLimit) === null || _memoryInfo_memoryLimit === void 0 ? void 0 : _memoryInfo_memoryLimit.toString()) || 'N/A';
    if (memoryInfo === null || memoryInfo === void 0 ? void 0 : memoryInfo.systemMemory) {
        calculateSystemMemory(telemetryReportData, memoryInfo.systemMemory);
    }
    if (memoryInfo === null || memoryInfo === void 0 ? void 0 : memoryInfo.appMemory) {
        calculateAppMemory(telemetryReportData, memoryInfo.appMemory);
    }
    if (memoryInfo === null || memoryInfo === void 0 ? void 0 : memoryInfo.processMemory) {
        calculateProcessMemory(telemetryReportData, memoryInfo.processMemory);
    }
}

//# sourceMappingURL=telemetry-utils.js.map